import PropTypes from "prop-types";

import { choiceProptype } from "@/view/PollContainer/PollProptypes";
import {
  resultsLabelCss,
  chosenOptionResultsLabelCss,
  noVotesResultsLabelCss,
} from "./ResultsLabel.style";

const propTypes = {
  choice: choiceProptype,
  userId: PropTypes.string,
};

const ResultsLabel = ({ choice, userId }) => {
  const { votes: voteCount, voter_ids: voterIds } = choice;

  const isUsersChosenOption = voterIds.includes(userId);

  if (voteCount === 0) {
    return <span css={noVotesResultsLabelCss}>Nobody chose this</span>;
  }

  if (isUsersChosenOption) {
    return (
      <span
        data-qa-selector="you-chose-list-poll-option"
        css={chosenOptionResultsLabelCss}
      >
        {voteCount === 1
          ? "You chose this"
          : `You and ${voteCount - 1} others chose this`}
      </span>
    );
  }

  return (
    <span css={resultsLabelCss}>
      {voteCount} {voteCount > 1 ? "students" : "student"} chose this
    </span>
  );
};

ResultsLabel.propTypes = propTypes;

export default ResultsLabel;
